<script setup lang="ts">
import ModalFreetour from "../../components/Modais/ModalFreetour.vue";
</script>
<template>
  <loading v-model:active="loading" :is-full-page="false" color="#b20000" />
  <div id="freetour-array-images">
    <div class="row" v-if="arrayImages.length">
      <div
        v-for="(item, index) in arrayImages"
        :class="item.imgHorizontal === 'true' ? 'col-lg-4 col-8' : 'col-lg-2 col-4'"
        :key="index"
      >
        <img
          :src="corrigirPath(item.imgSrc)"
          :alt="item.name"
          :title="item.name"
          @click="zoomImage(item.imgSrc)"
          width="406"
          height="263"
        />
      </div>
    </div>
  </div>
  <ModalFreetour @showModalFreetour="showModalFreetour" :options="options" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import api from "../../api";
import Loading from "vue-loading-overlay";

export default defineComponent({
  name: "BoxArrayImages",
  components: {
    Loading,
  },
  data() {
    return {
      arrayImages: [] as Array<any>,
      loading: false,
      options: {
        showFreetour: false,
        imgFreetour: "",
      },
    };
  },
  created() {
    this.getArrayImages();
  },
  methods: {
    getArrayImages() {
      this.loading = true;
      if (!sessionStorage.getItem("arrayImages"))
        api
          .get("v1/home/getImagesFreeTour")
          .then(({ data }) => {
            const { arrayImagesFreeTour } = data;
            let arrayHorizontal = new Array();
            let arrayVertical = new Array();
            arrayImagesFreeTour.forEach((element) => {
              element.imgHorizontal === "true"
                ? arrayHorizontal.push(element)
                : arrayVertical.push(element);
            });
            let arrayCompleto = new Array();

            arrayCompleto[0] = arrayHorizontal[0];

            for (let i = 0; i < arrayVertical.length; i++) {
              arrayCompleto.push(arrayVertical[i]);
              if (i === 7) {
                arrayCompleto[9] = arrayHorizontal[1];
                arrayCompleto[10] = arrayHorizontal[2];
              }
            }
            this.arrayImages = arrayCompleto;
            sessionStorage.setItem("arrayImages", JSON.stringify(this.arrayImages));
          })
          .finally(() => (this.loading = false));
      else {
        this.arrayImages = JSON.parse(sessionStorage.getItem("arrayImages"));
        this.loading = false;
      }
    },
    corrigirPath(path: string) {
      return path.replace("image", "thumb");
    },
    showModalFreetour(data) {
      this.options.showFreetour = data.show;
      this.options.imgFreetour = data.img;
    },
    zoomImage(src) {
      this.showModalFreetour({ show: true, img: src });
    },
  },
});
</script>
<style scoped lang="css">
img {
  width: 100% !important;
  object-fit: cover;
  height: 263px;
  cursor: pointer;
}

.row > [class*="col-"] {
  padding: 6px 6px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  img {
    width: 100% !important;
    object-fit: cover;
    height: auto;
  }

  .row > [class*="col-8"] {
    width: 100%;
  }

  .row > [class*="col-4"] {
    width: 50%;
  }
}
</style>
